import React, { useState, useEffect } from 'react';

const ArticleList = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await fetch('https://dev.to/api/articles?username=leoneloliver');
        const data = await response.json();
        setArticles(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchArticles();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="max-w-6xl mx-auto">
      {articles.map(article => (
        <div key={article.id} className="bg-white shadow-md p-4 mb-4 flex rounded-lg">
          {/* Conditionally render image for non-mobile devices */}
          <div className="w-1/3 md:block hidden">
            <img src={article.cover_image} alt={article.title} className="w-full rounded-l-lg" />
          </div>
          <div className="w-full md:w-2/3 p-4"> {/* Adjust width for mobile devices */}
            <h2 className="text-xl font-bold mb-2">{article.title}</h2>
            {/* <p className="text-gray-700 mb-2">{article.description}</p> */}
            <p className="text-sm text-gray-500 mb-2">Published on {formatDate(article.published_at)}</p>
            <a
              href={article.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-900 hover:text-white  hover:bg-gray-900 inline-block mt-2 px-4 py-2 border border-gray-900 rounded-full"
            >
              Read more
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ArticleList;
